export default "__VITE_ASSET__Cwg1SvLz__"